import styled from "styled-components";

export const Wrapper = styled.div`
display: flex;
position: relative;
width: 100%;
height: 100%;
flex-direction: column;
`;